
import { Image } from 'vue-datocms'
import { getIcon } from '~/utils/get-icon.js'
import GlobalSearch from '~/components/site-nav/global-search.vue'

export default {
  components: {
    'datocms-image': Image,
    GlobalSearch,
  },

  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },

    // Optional
    subtitle: {
      type: String,
      default: '',
    },

    cta: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    hasActions() {
      return this.cta.length > 0
    },
  },

  methods: {
    getButtonIcon(key) {
      return getIcon(key)
    },
  },
}
